import { ChangeEvent } from 'react';

import styles from './styles.module.css';
import Loader from '../Loader';
import CrossIcon from '@/assets/icons/cross.svg?react';
import SearchIcon from '@/assets/icons/search.svg?react';

interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  customClass?: string;
  showLoader?: boolean;
  showCross?: boolean;
  resetSearch?: () => void;
}

const SearchInput = ({
  placeholder = 'Search',
  value = '',
  onChange = () => {},
  customClass = '',
  showLoader = false,
  showCross = false,
  resetSearch = () => {}
}: SearchInputProps) => {
  return (
    <div className={`${styles.searchContainer} ${customClass || ''}`}>
      <SearchIcon className={styles.searchIcon} />
      <input
        id={`${placeholder}-search-input`}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={styles.searchInput}
      />
      <div className={styles.inputIcons}>
        {showLoader && (
          <span id={`${placeholder}-loader`} className={styles.icon}>
            <Loader size="small" />
          </span>
        )}
        {showCross && (
          <span
            id={`${placeholder}-cross`}
            className={styles.icon}
            onClick={() => resetSearch()}
          >
            <CrossIcon />
          </span>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
